import React from "react";
import "../styles/DeleteAccount.css";

const DeleteAccount = () => {
  return (
    <div className="delete-wrapper">
      <div className="delete-container">
        <h1 className="delete-title">Delete Account & Data – Lookit</h1>

        <p className="delete-text">
          This page explains how users can request deletion of their account and
          associated personal data from the <strong>Lookit</strong> mobile application.
        </p>

        <section className="delete-section">
          <h2>How to Request Account Deletion</h2>
          <p>
            To delete your account, please send an email with the details below:
          </p>

          <div className="delete-email-box">
            <p><strong>Email:</strong> p2pswap786@gmail.com</p>
            <p><strong>Subject:</strong> Delete My Account</p>
          </div>

          <p>Please include the following information in your email:</p>
          <ul>
            <li>Email address or phone number used to register in the app</li>
            <li>Username (if applicable)</li>
          </ul>

          <p>
            This information is required to verify your identity and process
            your request securely.
          </p>
        </section>

        <section className="delete-section">
          <h2>Data That Will Be Deleted</h2>
          <ul>
            <li>User account information</li>
            <li>Profile details</li>
            <li>Login credentials</li>
            <li>App-related personal data associated with your account</li>
          </ul>
        </section>

        <section className="delete-section">
          <h2>Processing Time</h2>
          <p>
            Account deletion requests are processed within
            <strong>90 working days </strong>
            after successful verification.
          </p>
        </section>

        <section className="delete-section">
          <h2>Data Retention</h2>
          <p>
            We do not retain any personal data after account deletion, except
            where retention is required by law or for legitimate business purposes.
            Any retained data will be stored only for the legally required period.
          </p>
        </section>

        <section className="delete-section">
          <h2>Contact</h2>
          <p>
            For questions related to account deletion or data privacy, contact us at:
          </p>
          <p className="delete-contact">p2pswap786@gmail.com</p>
        </section>

        <footer className="delete-footer">
          Last Updated: 05 January 2026
        </footer>
      </div>
    </div>
  );
};

export default DeleteAccount;
